import React from 'react';
import Button from '../../../../components/shared/button';
import Icon from '../../../../components/shared/icon';
import OKIcon from '../../../../assets/icons/ok.svg';
import WarningIcon from '../../../../assets/icons/warning.svg';
import ErrorIcon from '../../../../assets/icons/error.svg';

import { useTranslation } from 'react-i18next';
import { Card } from 'react-bootstrap';
import { ElsaPurchaseStatus } from '../../../../models/elsa-models';

function ActiveBlock({ price, summary, handleClick, purchaseStatus, isFree, canActivate, btnUrl }) {

  const { t: trans } = useTranslation();

  const renderStatusTag = () => {
    switch (purchaseStatus) {
      case ElsaPurchaseStatus.Accepted:
        return <span className='purchase-status active'><Icon icon={OKIcon} classes="xs" />{trans('detail.activated')}</span>
      case ElsaPurchaseStatus.Rejected:
        return <span className='purchase-status rejected'><Icon icon={ErrorIcon} classes="xs" /> {trans('detail.rejected')}</span>
      case ElsaPurchaseStatus.Pending:
        return <span className='purchase-status pending'><Icon icon={WarningIcon} classes="xs" /> {trans('detail.pending')}</span>
      default:
        return '';
    }
  }

  return (
    <Card>
      <Card.Body>
        {
          isFree ?
            <>
              <p className='price'>{trans('detail.purchase.price')}</p>
              <p className='type'>{trans('result.per-company')}</p>
              <p className='text-center'>
                {trans('detail.purchase.free-use')}
              </p>
              <p className="free-for-use">
                <span className='note'>
                  {trans('detail.purchase.note')}
                </span>
                {trans('detail.purchase.note-text')}
              </p>
            </>
            :
            <>
              <p className='price'>{price}</p>
              <p className='type'>{trans('result.per-company')}</p>
              <p className='text-center'>
                {summary ? summary : <p>{trans('common-action.content-not-found')}</p>}
              </p>
            </>
        }
        {
          canActivate ?
            (
              purchaseStatus === null ? <Button text={trans('detail.active')} classes="round activate" handleClick={handleClick}></Button> : renderStatusTag()
            ) : (
              <a target="_blank" rel="noopener noreferrer" className="btn-ue more" href={btnUrl}>{trans('result.more')}</a>
            )
        }
      </Card.Body>
    </Card>
  );
}

export default ActiveBlock;